import React, { Fragment, createContext, useMemo, useState } from 'react'
import styles from './app.styles'
import injectSheet from 'react-jss'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Header from 'pobble-components/dist/pobble-header'
import Pupil from '../pages/pupil/pupil.container'
import AddPupils from '../pages/add-pupils/add-pupils'
import SchoolOverview from '../pages/school-overview/school-overview'
import ConflictResolution from '../pages/conflict-resolution/conflict-resolution.container'
import { UserProvider, UserInspector } from 'pobble-components/dist/pobble-user'
import EnvironmentLine from 'pobble-components/dist/environment-line'
import PageNotFound from 'pobble-components/dist/page-not-found'
import { SubscriptionProvider } from 'pobble-components/dist/subscriptions'
import PsermissionWarning from '../permission-warning/permission-warning'
import { ErrorBoundary } from 'pobble-components/dist/error-boundary'

const APP_PATH = process.env.REACT_APP_PATH || '/'

export const AppContext = createContext()

const App = ({ me, meError }) => {
  const [permissionWarning, setPermissionWarning] = useState({
    open: false,
    action: null
  })

  const contextValue = useMemo(
    () => {
      return {
        permissionWarning: ({ action }) =>
          setPermissionWarning({ open: true, action })
      }
    },
    [setPermissionWarning]
  )
  return (
    <AppContext.Provider value={contextValue}>
      <UserProvider
        fetchMe={() => (me ? Promise.resolve(me) : Promise.reject(meError))}>
        <SubscriptionProvider>
          <Router basename={APP_PATH}>
            <Fragment>
              <EnvironmentLine />
              <Header activePage="dashboard" />
              <ErrorBoundary>
                <UserInspector schoolRequired>
                  <Fragment>
                    <Switch>
                      <Route
                        exact
                        path="/(|groups)/"
                        component={SchoolOverview}
                      />
                      <Route path="/pupil/:pupilId" component={Pupil} />
                      <Route path="/add-pupils" component={AddPupils} />
                      <Route
                        path="/conflict-resolution"
                        component={ConflictResolution}
                      />
                      <Route component={PageNotFound} />
                    </Switch>
                  </Fragment>
                </UserInspector>
              </ErrorBoundary>
            </Fragment>
          </Router>
          <PsermissionWarning
            action={permissionWarning.action}
            requestClose={() =>
              setPermissionWarning({ ...permissionWarning, open: false })
            }
            isOpen={permissionWarning.open}
          />
        </SubscriptionProvider>
      </UserProvider>
    </AppContext.Provider>
  )
}

export default injectSheet(styles)(App)
